// extracted by mini-css-extract-plugin
export default {"options-entry":"TasksController_options-entry__-Vfcu","dropdown-input":"TasksController_dropdown-input__riZYs","header-options":"TasksController_header-options__MT7zV"};